import { render, staticRenderFns } from "./SideWidgetBlogOverview.vue?vue&type=template&id=58553512&"
import script from "./SideWidgetBlogOverview.vue?vue&type=script&lang=js&"
export * from "./SideWidgetBlogOverview.vue?vue&type=script&lang=js&"
import style0 from "./SideWidgetBlogOverview.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports